module.exports = __webpack_public_path__ + "img/18-about.5d05564b.jpg";